import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
//import "./App.css"; // This should contain your custom CSS
import "./LoanSection.css";

const LoanSection = ({
  className,
  imageUrl,
  heading,
  highlight,
  features,
  imgSrc,
}) => (
  <section className={`${className} text-light`}>
    <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
    <div
      className="container position-relative"
      style={{ zIndex: 2 }}>
      <div className="row align-items-center">
        <div className="col-md-7">
          <h2 className="display-5 fw-bold">
            {heading} <span>{highlight}</span>
          </h2>
          <ul className="list-unstyled mt-4 fs-5">
            {features.map((feature, idx) => (
              <li key={idx}><i className={`me-2 ${feature.icon}`}></i>{feature.text}</li>
            ))}
          </ul>
          <a href="apply-now" className="btn mortbuzzbubtn-apply btn-lg mt-3">
            <i className="fas fa-file-signature me-2"></i> Apply Now
          </a>
        </div>
        <div className="col-md-5 text-center d-none d-md-block">
          <img
            src={imgSrc}
            alt="Loan Illustration"
            className="img-fluid-mortbuzz"
            style={{ maxHeight: "300px" }}
          />
        </div>
      </div>
    </div>
  </section>
);

const App = () => {
  return (
    <>
      <LoanSection
        className="home-loan-section-m"
        imageUrl="https://mortbuzz.in/wp-content/uploads/2025/04/wp2406649-luxury-house-wallpapers-scaled.jpg"
        heading="Home Loans Starting At"
        highlight="7.35%*"
        imgSrc="/images/FrontPage/homeloancircle.png"
        features={[
          { icon: "fas fa-coins", text: "Upto 100% Cashback On All Bank Charges" },
          { icon: "fas fa-university", text: "Loan from Public Sector Only" },
          { icon: "fas fa-rupee-sign", text: "Flexible EMI Options Tailored to Your Needs" },
          { icon: "fas fa-thumbs-up", text: "Guaranteed low interest home loan in Pune" },
          { icon: "fas fa-percent", text: "Zero Processing Fees on Selected Banks" },
          { icon: "fas fa-home", text: "Doorstep Services" },
          { icon: "fas fa-tachometer-alt", text: "Loan Agents In Pune" },
        ]}
      />
        <LoanSection
        className="loan-against-section"
        imageUrl=""
        heading="Loan Against Property Starting At"
        highlight="8.40%*"
        imgSrc="/images/FrontPage/loanagainstpropertycircle.png"
        features={[
          { icon: "fas fa-coins", text: "Funding Upto 100% of Market Value" },
          { icon: "fas fa-university", text: "Attractive Interest Rates Starting from 8.40%*" },
          { icon: "fas fa-rupee-sign", text: "100% Cashback of all Bank Charges" },
          { icon: "fas fa-thumbs-up", text: "Quick Disbursal Within 48 Hours*" },
          { icon: "fas fa-percent", text: "low interest LAP in Pune with Door Step Service" },
            { icon: "fas fa-home", text: "Morgage Loan Services In Pune" },
          
       ]}
      />


         <LoanSection
        className="balance-transfer-section"
        imageUrl="https://mortbuzz.in/wp-content/uploads/2025/05/education-loan-1.png"
        heading=" Education Loan Starting At"
        highlight="7.10%*"
        imgSrc="/images/FrontPage/educationloancircle.png"
        features={[
          { icon: "fas fa-coins", text: "Easy to Apply Education Loan" },
          { icon: "fas fa-university", text: "Loan from Public Sector Only" },
          { icon: "fas fa-rupee-sign", text: "Attractive Interest Rates for Indian & Foreign Studies" },
          { icon: "fas fa-thumbs-up", text: "Guaranteed Lowest Rate of Interest" },
          { icon: "fas fa-percent", text: "Moratorium Period Available During Study Time" },
          { icon: "fas fa-home", text: "Apply For Loan Online In Pune With Doorstep Services" },
          
       ]}
      />

          <LoanSection
        className="bussiness-loan-section"
        imageUrl="https://mortbuzz.in/wp-content/uploads/2025/05/bussineloanimage.png"
        heading=" Bussiness Loans Starting At"
        highlight="9.00%*"
        imgSrc="/images/FrontPage/businessloancircle.png"
        features={[
          { icon: "fas fa-coins", text: "Power Your Business Property Goals" },
          { icon: "fas fa-university", text: "OD/CC Facility Available" },
          { icon: "fas fa-rupee-sign", text: "MSME / CGTMSE Loan Facility Available" },
          { icon: "fas fa-thumbs-up", text: "Project Funding Available" },
          { icon: "fas fa-percent", text: "200% Funding Available in Hybrid Loan." },
          { icon: "fas fa-home", text: "business loan in Pune for MSMEs with Doorstep Services" },
          
       ]}
      />



        <LoanSection
        className="personal-loan-section"
        imageUrl="https://mortbuzz.in/wp-content/uploads/2025/05/personal-loan-fina-pc-view.png"
        heading="Personal Loans Starting At"
        highlight="10.35%*"
        imgSrc="/images/FrontPage/personalloancircle.png"
        features={[
          { icon: "fas fa-coins", text: "Upto 100% Cashback On All Bank Charges" },
          { icon: "fas fa-university", text: "instant personal loan approval" },
          { icon: "fas fa-rupee-sign", text: "Minimal Documentation" },
          { icon: "fas fa-thumbs-up", text: "Quick Disbursal Within 48 Hours*" },
          { icon: "fas fa-percent", text: "Trusted Loan Agency In Pune" },
          { icon: "fas fa-home", text: "Personal & Business Loan In Pune Doorstep Service" },
          
       ]}
      />


       <LoanSection
        className="car-loan-section"  
        imageUrl=""
        heading="Car Loans Starting At"
        highlight="7.60%*"
        imgSrc="/images/FrontPage/car-loan-infograph.png"
        features={[
          { icon: "fas fa-coins", text: "Funding up to 90% of On-Road Price" },
          { icon: "fas fa-university", text: "Attractive Interest Rates" },
          { icon: "fas fa-rupee-sign", text: "Minimal Documentation" },
          { icon: "fas fa-thumbs-up", text: "Available for New Cars" },
          { icon: "fas fa-percent", text: "Car Loan In Pune" },
          { icon: "fas fa-home", text: "Car Loan In Pune Doorstep Service" },
          
       ]}
      />
    </>
  );
};

export default App;
